"use client";

import { SearchIcon } from "lucide-react";

const DiscoverCommunitySearch = ({ onChange }: { onChange: (query: string) => void }) => {
	return (
		<div className="mx-auto flex w-full max-w-3xl items-center gap-2">
			<div className="group relative flex max-w-6xl cursor-pointer flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-300 pl-3 text-base lg:w-full">
				<div className="my-auto flex w-full items-center gap-2 self-stretch">
					<SearchIcon className="h-5 w-5" />

					<input
						type="text"
						id="search-input"
						placeholder="Search for communities"
						autoComplete="off"
						onChange={(e) => onChange(e.currentTarget.value)}
						className="my-auto w-full self-stretch border-none bg-transparent py-3 placeholder:text-gray-400 focus:outline-none"
					/>
				</div>
			</div>
		</div>
	);
};

export default DiscoverCommunitySearch;
